"use client";
// In order to prevent Theme UI from adding extra elements, which breaks certain layouts,
// we need to use the internal context to change the theme rather than the preferred
// ThemeProvider React component
import {
  __ThemeUIContext,
  __ThemeUIInternalBaseThemeProvider
} from "@theme-ui/core";
import React from "react";
import { Theme as ThemeUITheme } from "theme-ui";

import { getTheme } from "./Theme";
import { ThemeContext } from "./ThemeContext";
import { ThemeBrandColors, ThemeMode } from "./types";

interface ThemeOverrideProps {
  children: React.ReactNode;
  mode?: ThemeMode;
  themeBrand?: ThemeBrandColors;
}

export const ThemeOverride: React.FC<ThemeOverrideProps> = ({
  children,
  mode,
  themeBrand
}) => {
  const {
    mode: modeInitial,
    brand: themeBrandInitial,
    ...other
  } = React.useContext(ThemeContext);
  const modeMerged = mode || modeInitial;
  const brandMerged = themeBrand || themeBrandInitial;

  const theme = React.useMemo(() => {
    return getTheme(brandMerged, modeMerged);
  }, [brandMerged, modeMerged]);
  const themeUIContext = React.useContext(__ThemeUIContext);

  return (
    <ThemeContext.Provider
      value={{
        ...other,
        mode: modeMerged,
        brand: brandMerged
      }}
    >
      <__ThemeUIInternalBaseThemeProvider
        context={{ ...themeUIContext, theme: theme as unknown as ThemeUITheme }}
      >
        {children}
      </__ThemeUIInternalBaseThemeProvider>
    </ThemeContext.Provider>
  );
};
